export const inScope = (ids, id) =>
  ids === null || ids === undefined || ids.includes(id);

export const canImportRoster = (permissions, permissionScopes) =>
  permissions.manageRoster && permissionScopes?.importRoster !== false;
